(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-slideshow"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const slideshow = document.querySelector(".custom-slideshow");
  if (!slideshow) return;

  const track = slideshow.querySelector(".slideshow-track");
  const slides = slideshow.querySelectorAll(".slide");
  const dots = slideshow.querySelectorAll(".pagination-dot");

  if (slides.length === 0) return;

  const autoRotate = slideshow.dataset.autorotate === "true";
  const slideSpeed = parseInt(slideshow.dataset.speed, 10) * 1000;

  let currentIndex = 0;
  let autoTimer = null;
  let isInteracting = false;
  let hasDragged = false;
  let startX = 0;
  let currentTranslate = 0;
  let prevTranslate = 0;

  function updateSliderPosition() {
    track.style.transform = `translateX(${currentTranslate}px)`;
  }

  function goToSlide(index) {
    currentIndex = index;
    if (currentIndex < 0) currentIndex = slides.length - 1;
    if (currentIndex >= slides.length) currentIndex = 0;

    const slideWidth = slideshow.offsetWidth;
    currentTranslate = -currentIndex * slideWidth;
    prevTranslate = currentTranslate;

    track.style.transition = "transform 0.4s ease-out";
    updateSliderPosition();

    dots.forEach((dot, i) => {
      dot.classList.toggle("active", i === currentIndex);
    });
  }

  function startAutoRotate() {
    if (!autoRotate || slides.length <= 1) return;
    stopAutoRotate();
    autoTimer = setInterval(() => {
      goToSlide(currentIndex + 1);
    }, slideSpeed);
  }

  function stopAutoRotate() {
    if (autoTimer) clearInterval(autoTimer);
  }

  // --- Mouse / Touch Tracking Logic ---

  function handlePointerDown(e) {
    isInteracting = true;
    hasDragged = false;
    stopAutoRotate();
    startX = e.type.includes("touch") ? e.touches[0].clientX : e.clientX;
    track.style.transition = "none";
  }

  function handlePointerMove(e) {
    if (!isInteracting) return;
    const currentX = e.type.includes("touch") ? e.touches[0].clientX : e.clientX;
    const deltaX = currentX - startX;

    if (Math.abs(deltaX) > 5) hasDragged = true;

    // Follow cursor directly
    currentTranslate = prevTranslate + deltaX;
    updateSliderPosition();
  }

  function handlePointerUp() {
    if (!isInteracting) return;
    isInteracting = false;

    const movedBy = currentTranslate - prevTranslate;

    // Transition to next/prev slide based on gesture distance
    if (movedBy < -50) {
      goToSlide(currentIndex + 1);
    } else if (movedBy > 50) {
      goToSlide(currentIndex - 1);
    } else {
      goToSlide(currentIndex);
    }

    startAutoRotate();
  }

  // Prevent a drag gesture from also triggering the slide's link
  slideshow.addEventListener("click", (e) => {
    if (hasDragged) {
      e.preventDefault();
      hasDragged = false;
    }
  }, true);

  // Mouse & Touch Events
  slideshow.addEventListener("mousedown", handlePointerDown);
  slideshow.addEventListener("mousemove", handlePointerMove);
  slideshow.addEventListener("mouseup", handlePointerUp);
  slideshow.addEventListener("mouseleave", () => {
    if (isInteracting) handlePointerUp();
  });

  slideshow.addEventListener("touchstart", handlePointerDown, { passive: true });
  slideshow.addEventListener("touchmove", handlePointerMove, { passive: true });
  slideshow.addEventListener("touchend", handlePointerUp);

  // Pagination Dot Clicks
  dots.forEach((dot) => {
    dot.addEventListener("click", (e) => {
      const idx = parseInt(e.currentTarget.dataset.index, 10);
      goToSlide(idx);
      startAutoRotate();
    });
  });

  // Resize handler for responsive width recalculations
  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => goToSlide(currentIndex), 150);
  });

  // Initialize
  goToSlide(0);
  startAutoRotate();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
